import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Card, CardBody, Row, Col, Button, Badge } from "reactstrap"

const Activity = () => {
  const [activityList, setActivityList] = useState([])

  const activities = useSelector(state => state.auth.activities)
  const user = useSelector(state => state.auth.user)

  // const activityList = [
  //   {
  //     event_name: `Hi ${user.first_name}, Congratulations! On starting your journey with Pula`,
  //     created_date: user.created_modified_at,
  //     status: "Completed",
  //     type: "profile",
  //   },
  //   // {
  //   //   event_name: "Reveiced PVS Card #PVS-123456",
  //   //   created_date: "27 Jan, 2026",
  //   //   status: "Approved",
  //   //   type: "pvs",
  //   // },
  //   // {
  //   //   event_name: "Participated in Bazaar 2025",
  //   //   created_date: "02 Feb, 2026",
  //   //   status: "Approved",
  //   //   type: "event",
  //   // },
  //   // {
  //   //   event_name: "Participated in Networking Meet 2025",
  //   //   created_date: "02 Feb, 2026",
  //   //   status: "Approved",
  //   //   type: "event",
  //   // },
  // ]

  useEffect(() => {
    
      let list = []
      if(activities.length > 0) list = [...activities]
      list.push({
        event_name: `Hi ${user.first_name}, Congratulations! On starting your journey with Pula`,
        created_date: user.created_modified_at,
        status: "Completed",
        type: "profile",
      })
      setActivityList(list)
  }, [activities])

  const getIconForActivityType = type => {
    switch (type) {
      case "pvs":
        return "mdi mdi-card-account-details"
      case "profile":
        return "mdi mdi-account-circle"
      case "event":
      case "past-event":
        return "mdi mdi-calendar-check"
      case "award":
      case "competition":
        return "mdi mdi-trophy"
      case "bazaar":
        return "mdi mdi-cart"
      case "lucky-draw":
        return "mdi mdi-gift"
      case "network-meet":
        return "mdi mdi-handshake"
      default:
        return "mdi mdi-information"
    }
  }

  const getTypeColor = type => {
    switch (type) {
      case "profile":
        return "welcome-color"
      case "pvs":
      case "pvs card number":
        return "pvs-color"
      case "lucky-draw":
      case "network-meet":
      case "award":
      case "competition":
      case "bazaar":
      case "past-event":
        return "event-color"
      case "cancelled":
        return "danger"
      default:
        return "secondary"
    }
  }

  const formatDate = dateString => {
    const date = new Date(dateString)
    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
    })
  }

  const getTitle = data => {
    if (data.type === "profile") {
      return `You Started Your Journey With Pula`
    } else if (data.type === "pvs") {
      return `You Received PVS Card #${data.pvs_card_number}`
    } else if (
      data.type === "lucky-draw" ||
      data.type === "network-meet" ||
      data.type === "award" ||
      data.type === "competition" ||
      data.type === "bazaar" ||
      data.type === "past-event"
    ) {
      return `Participated In ${data.event_name}`
    }
  }

  return (
    <div>
      <h4 className="font-size-18 mb-0 nom-title">{`${user.first_name}'s Timeline`}</h4>
      {/* Timeline */}
      <div className="d-flex align-items-center justify-content-center">
        <div className="timeline">
          {activityList.map((activity, index) => (
            <div
              key={activity.id}
              className={`timeline-item ${
                index % 2 === 0 ? "timeline-item--left" : "timeline-item--right"
              }`}
            >
              {/* Timeline Line */}
              {index < activityList.length - 1 && (
                <div className="timeline-line"></div>
              )}

              {activityList.length === 1 && (
                <div className="timeline-line" style={{ height: "20%" }}></div>
              )}

              {/* Timeline Dot */}
              <div className={`timeline-dot ${getTypeColor(activity.type)}`}>
                <i
                  className={`${getIconForActivityType(
                    activity.type
                  )} timeline-icon`}
                ></i>
              </div>

              {/* Timeline Content */}
              <div
                className={`timeline-content ${getTypeColor(activity.type)}`}
              >
                <div
                  className={`d-flex flex-column mt-1 ${
                    index % 2 === 0 ? "align-items-end" : "align-items-start"
                  }`}
                >
                  <h5 className="font-size-16 mt-1 mb-1">
                    {getTitle(activity)}
                  </h5>
                  <div className="d-flex align-items-center gap-2 mb-2">
                    {/* <Badge color={getStatusColor(activity.status)} pill>
                      {activity.status}
                    </Badge> */}
                    <small className="text-white">
                      <i className="bx bx-calendar me-1"></i>
                      {`Date: ${formatDate(activity.created_date)}`}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* {activities.length > 0 && (
        <Row className="mt-3">
          <Col md="12" className="text-center">
            <Button color="light" size="sm">
              Load More Activities
            </Button>
          </Col>
        </Row>
      )} */}

      {/* Custom Styles */}
      <style jsx>{`
        .timeline {
          position: relative;
          padding: 10px 0;
          width: 70%;
        }

        .timeline-item {
          position: relative;
          display: flex;
          min-height: 80px;
          margin-top: 24px;
          align-items: flex-end;
        }

        .timeline-line {
          position: absolute;
          left: 50%;
          top: 20px;
          width: 2px;
          height: calc(100% + 60px);
          background-color: #e9ecef;
          transform: translateX(-50%);
        }

        .timeline-line--single {
          top: -60px;
          height: 60px;
        }

        .welcome-color {
          background: linear-gradient(135deg, #ff69b4, #b86cff);
        }

        .pvs-color {
          background: linear-gradient(135deg, #1fbf75, #0f9d58);
        }

        .event-color {
          background: linear-gradient(135deg, #4facfe, #00c6ff);
        }

        .timeline-dot {
          position: absolute;
          left: 50%;
          top: 50px;
          width: 25px;
          height: 25px;
          background-color: #fff;
          // border: 2px solid #7367f0;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1;
          transform: translateX(-50%);
        }

        .timeline-icon {
          font-size: 12px;
          color: #fff;
        }

        .timeline-content {
          width: calc(50% - 20px);
          padding: 10px 24px;
          box-sizing: border-box;
          border-radius: 10px;
          margin-top: 50px;
          color: #fff;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
        }

        .timeline-item--left {
          justify-content: flex-start;
        }

        .timeline-item--left .timeline-content {
          text-align: right;
          padding-right: 20px;
          margin-right: 20px;
          max-width: calc(50% - 20px);
        }

        .timeline-item--right {
          justify-content: flex-end;
        }

        .timeline-item--right .timeline-content {
          padding-left: 20px;
          margin-left: 20px;
          max-width: calc(50% - 20px);
        }

        @media (max-width: 768px) {
          .timeline {
            padding: 0;
          }

          .timeline-line {
            left: 16px;
            transform: none;
          }

          .timeline-dot {
            left: 16px;
            transform: none;
          }

          .timeline-content {
            width: 100%;
            padding-left: 20px;
            padding-right: 0;
            text-align: left;
          }

          .timeline-item--left,
          .timeline-item--right {
            justify-content: flex-start;
          }

          .timeline-item--left .timeline-content,
          .timeline-item--right .timeline-content {
            text-align: left;
            padding-left: 48px;
            padding-right: 0;
          }
        }

        .activity-details {
          background-color: #f8f9fa;
          padding: 15px;
          border-radius: 8px;
          margin-top: 10px;
        }

        .detail-item {
          display: flex;
          margin-bottom: 8px;
        }

        .detail-item:last-child {
          margin-bottom: 0;
        }

        .detail-label {
          font-weight: 600;
          color: #495057;
          min-width: 120px;
          margin-right: 10px;
        }

        .detail-value {
          color: #6c757d;
          flex: 1;
        }
      `}</style>
    </div>
  )
}

export default Activity
